import styled from "styled-components";

const Margin = styled.div`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  height: ${(props) => props.height2};
  
`;

export default Margin;
